// 「前回置いた図形の種別」を localStorage に保存する。
// 空白部のダブルクリックと、空白部の右クリックメニューの「図形を配置」が、この値を使って
// 同じ種別の新しい図形を置く。配置前ツールバーの選好（text-size-preference など）と同じ作法で、
// 読み取り・保存とも例外を握って既定値へ落とす。

const KEY = "refinement-canvas:last-placed-object-kind";

// 1 クリックで完結する配置の種別。ペン（ストロークの形が要る）とコメント（図形ではなく
// 入力ウィンドウを開く操作）は、ダブルクリックで再現できないため含めない。
const PLACEABLE_KINDS = ["sticky", "section", "shape", "text", "table", "stamp"] as const;

export type PlaceableObjectKind = (typeof PLACEABLE_KINDS)[number];

/** 保存値が無い・壊れている・未知の種別のときに使う既定。 */
export const DEFAULT_PLACED_OBJECT_KIND: PlaceableObjectKind = "text";

function isPlaceableObjectKind(value: string): value is PlaceableObjectKind {
  return (PLACEABLE_KINDS as readonly string[]).includes(value);
}

export function loadLastPlacedObjectKind(): PlaceableObjectKind {
  try {
    const raw = window.localStorage.getItem(KEY);
    if (raw === null || !isPlaceableObjectKind(raw)) return DEFAULT_PLACED_OBJECT_KIND;
    return raw;
  } catch {
    // プライベートブラウジングなどで localStorage を読めない環境でも配置はできるようにする。
    return DEFAULT_PLACED_OBJECT_KIND;
  }
}

/**
 * 前回置いた種別を保存する。保存できなくても配置自体は成功扱いとし、通知もしない。
 * 「利用者が選んだ設定」ではなく「操作の履歴」であり、失敗しても次回が既定へ戻るだけで実害が無いため、
 * text-size-preference のようなロールバック・通知は行わない。
 */
export function saveLastPlacedObjectKind(kind: PlaceableObjectKind): void {
  try {
    window.localStorage.setItem(KEY, kind);
  } catch {
    // 保存できない環境では記録を諦める。
  }
}
